import { type ReactNode } from "react";

import { getAnalyticsWebClientPromise } from "@atlassian/wac-analytics-web-client-async";
import BaseCrossFlowProvider from "@atlassiansox/cross-flow-support/wac";

import { getUsersPlugin } from "./utils";

export type CrossFlowProviderProps = {
    children: ReactNode;
    cloudId?: string;
    locale?: string;
};

const getAnalyticsWebClientInstance = () =>
    getAnalyticsWebClientPromise().then((client) => client.getInstance());

export const CrossFlowProvider = ({
    children,
    cloudId,
    locale = "en"
}: CrossFlowProviderProps) => (
    <BaseCrossFlowProvider
        cloudId={cloudId}
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient={getAnalyticsWebClientInstance()}
        locale={locale}
        plugins={[getUsersPlugin]}
    >
        {children}
    </BaseCrossFlowProvider>
);
